import { render } from "./PersonalTicket.vue?vue&type=template&id=37d97447&scoped=true"
import script from "./PersonalTicket.vue?vue&type=script&lang=js"
export * from "./PersonalTicket.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=37d97447&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d97447"]])

export default __exports__